<template>
  <div class="c-nodata" v-if="nodata">
    <Icon type="ios-filing-outline" size="92" color="#efefef" />
  </div>
  <div class="c-account-item" v-else>
    <div v-for="item in drops" :key="item.id" :class="itemClasses(item)" @click="$emit('on-child', { current: item.id, level })">
      <div v-if="item.children && item.children.length" class="c-item c-check-item">
        <Checkbox
          v-show="level !== 1"
          v-model="item.check"
          :indeterminate="itemIndeterminate(item)"
          style="margin: 0 8px 0 0"
          :disabled="item.lock || disabled"
        />
        <span
          >{{ item.name }} <ins style="color: #ff9900" v-show="count(item.children)">({{ count(item.children) }})</ins></span
        >
        <Icon type="ios-arrow-forward" class="c-check-arrow" size="14" color="#c1c1c1" />
        <span class="c-item-checkbox c-cataract" @click="selectItem(item)"></span>
      </div>
      <div v-else class="c-item c-check-item">
        <Checkbox v-show="level !== 1" v-model="item.check" :disabled="item.lock || disabled" />
        <span>{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { computeChild, mergeArray, isEmpty, trim } from '@/common/js/utils' // isArray,
export default {
  name: 'accountItem',
  props: {
    value: {
      type: [String, Number]
    },
    data: {
      type: Array
    },
    keyword: {
      type: String,
      default: ''
    },
    level: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  computed: {
    itemClasses() {
      return (item) => {
        const cls = ['m-account']
        item.id === this.value && cls.push('active')
        if (this.disabled || item.lock) cls.push('m-disabled')
        return cls
      }
    },
    nodata() {
      const no = Boolean(this.data.length)
      return !no
    },
    count() {
      return (child) => {
        const reducePlan = (ret, arr) => {
          ret.forEach((met) => {
            if (met.plan && met.check) {
              const bool = arr.map((t) => t.id).includes(met.id)
              !bool && arr.push(met)
            }
            if (met.children && met.children.length) arr = mergeArray(arr, reducePlan(met.children, arr))
          })
          return arr
        }
        const c = reducePlan(child, [])
        return c.length
      }
    },
    drops() {
      const keyword = trim(this.keyword).toLowerCase()
      return this.data.filter((ret) => isEmpty(keyword) || ret.name.toLowerCase().includes(keyword))
    }
  },
  methods: {
    selectItem(item) {
      this.$emit('on-select', {
        check: !item.check,
        level: this.level,
        cat: item.id
      })
    },
    itemIndeterminate(child) {
      const hasChild = (meta) => {
        return meta.children.reduce((sum, item) => {
          let foundChilds = []
          if (item.check) sum.push(item)
          if (item.children) foundChilds = hasChild(item)
          return sum.concat(foundChilds)
        }, [])
      }
      const some = hasChild(child).length > 0
      const every = child.children && child.children.every((ret) => ret.check)
      return some && !every
    }
  },
  watch: {
    data: {
      handler(nVal, oVal) {
        computeChild(nVal, this)
      },
      deep: true
    }
  },
  mounted() {
    computeChild(this.data, this)
  }
}
</script>
<style lang="scss" scoped>
.c-account-item {
  width: 100%;
  height: 36px;
  line-height: 20px;
  position: relative;

  .m-account {
    padding: 8px 12px;
    display: flex;

    &:hover {
      background-color: #f8f8f8;
    }

    &.active {
      color: #598fe6;
      background-color: #f8f8f8;

      .c-check-arrow {
        color: #598fe6 !important;
      }
    }

    .c-item-checkbox {
      width: 14px;
      height: 100%;
    }
  }

  .c-cataract {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 8;
    cursor: pointer;
  }

  .m-disabled {
    color: #ccc;

    &.active {
      color: #a5bada;

      .c-check-arrow {
        color: #a5bada !important;
      }
    }

    .c-cataract {
      visibility: hidden;
    }
  }

  .c-item {
    width: 100%;
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      width: calc(100% - 38px);
      line-height: 20px;
      word-break: break-all;
    }
  }

  .c-lock {
    cursor: pointer;
    padding: 0 8px 0 0;
    display: flex;
    align-items: center;
  }

  ::v-deep .ivu-checkbox-indeterminate {
    .ivu-checkbox-inner {
      background-color: #6fb3fb;
      border-color: #6fb3fb;
    }
  }
}

.c-nodata {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .ivu-icon {
    display: inline-block;
  }
}
</style>
